import Skeleton from "react-loading-skeleton";

import { DashboardCard2 } from "@/components/layout/DashboardCard2";
import profileBgArt from "@/assets/images/common/profileBgArt.svg";

import "react-loading-skeleton/dist/skeleton.css";

function SidebarSkeleton() {
  return (
    <div
      className="tw:w-full tw:rounded tw:bg-fill-bright-purple-primary tw:lg:h-162.5"
      style={{
        backgroundImage: `url(${profileBgArt})`,
        backgroundPositionY: "100%",
        backgroundRepeat: "no-repeat",
        backgroundSize: "contain",
      }}
    >
      <div className="tw:flex tw:flex-row tw:items-center tw:py-6 tw:lg:flex-col tw:lg:justify-center tw:lg:py-0">
        <div className="tw:mx-4 tw:lg:mx-0 tw:lg:mt-12 tw:lg:mb-6">
          <div className="tw:size-16.25 tw:leading-none tw:lg:size-30">
            <Skeleton circle height="100%" width="100%" />
          </div>
        </div>
        <div className="tw:flex tw:flex-col tw:gap-2 tw:leading-none tw:lg:items-center">
          <Skeleton height={16} width={130} />
          <Skeleton height={12} width={90} />
        </div>
      </div>
    </div>
  );
}

function BasicInfoSkeleton() {
  return (
    <DashboardCard2 className="tw:mb-4" title={<Skeleton width={160} />}>
      <div className="tw:grid tw:grid-cols-1 tw:gap-x-6 tw:gap-y-5 tw:pt-4 tw:md:grid-cols-2">
        {Array.from({ length: 7 }).map((_, i) => (
          <div className="tw:flex tw:flex-col tw:gap-1.5" key={i}>
            <Skeleton height={11} width={80} />
            <Skeleton height={14} width={160} />
          </div>
        ))}
      </div>
    </DashboardCard2>
  );
}

function StatesToPracticeSkeleton() {
  return (
    <DashboardCard2 className="tw:mb-4" title={<Skeleton width={160} />}>
      <div className="tw:flex tw:flex-col tw:gap-4 tw:pt-4">
        {Array.from({ length: 3 }).map((_, i) => (
          <Skeleton height={14} key={i} width={220} />
        ))}
      </div>
    </DashboardCard2>
  );
}

function AcceptedInsuranceSkeleton() {
  return (
    <DashboardCard2 className="tw:mb-4" title={<Skeleton width={160} />}>
      <div className="tw:flex tw:flex-col tw:gap-3 tw:pt-4">
        {Array.from({ length: 5 }).map((_, i) => (
          <Skeleton height={14} key={i} width={180} />
        ))}
      </div>
    </DashboardCard2>
  );
}

function WorkingHoursSkeleton() {
  return (
    <DashboardCard2 className="tw:mb-4" title={<Skeleton width={130} />}>
      <div className="tw:flex tw:flex-col tw:gap-4 tw:pt-4">
        {Array.from({ length: 7 }).map((_, i) => (
          <div className="tw:flex tw:flex-col tw:gap-1.5" key={i}>
            <Skeleton height={11} width={70} />
            <Skeleton height={14} width={200} />
          </div>
        ))}
      </div>
    </DashboardCard2>
  );
}

export function ProfileSkeleton() {
  return (
    <div className="tw:flex tw:flex-col tw:lg:flex-row tw:lg:gap-0" data-public="true">
      <div className="tw:my-3 tw:lg:my-0 tw:lg:w-3/12">
        <SidebarSkeleton />
      </div>
      <div className="tw:lg:w-9/12 tw:lg:px-8">
        <BasicInfoSkeleton />
        <StatesToPracticeSkeleton />
        <AcceptedInsuranceSkeleton />
        <WorkingHoursSkeleton />
      </div>
    </div>
  );
}
